/** @jsxImportSource @emotion/react */

import {
  Button,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { css } from "@emotion/react";
import React from "react";
import { MOBLIE_VIEW_WIDTH } from "../../../constants/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import MeiliSearch from "meilisearch";
import { useEffect } from "react";
import { v4 } from "uuid";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const SearchText = (theme, matchesMob) => css`
  font-size: ${matchesMob ? "60px" : "36px"};
  line-height: ${matchesMob ? "70px" : "36px"};
  font-family: ${theme.typography.MBCORPOA};
  position: relative;
  :after {
    content: "";
    position: absolute;
    width: 71px;
    height: 2px;
    top: unset;
    bottom: ${matchesMob ? "-35px" : "-10px"};
    left: 0;
    right: unset;
    background-color: #000;
  }
`;

const boxSectionCSS = css`
  text-align: left;
  color: #666;
  margin: 24px 0 40px;
  font: normal 500 20px/28px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
`;

const searchLi = css`
  :first-of-type {
    border-top: solid 1px rgba(0, 0, 0, 0.2);
  }
  width: 100%;
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
  padding-top: 24px;
  padding-bottom: 40px;
  position: relative;
  cursor: pointer;
`;

const primaryTextDesktop = css`
  font: normal 500 20px/28px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  font-weight: 500;
  text-align: left;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
`;

const secondaryTextDeskTop = css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  font-weight: normal;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
  letter-spacing: normal;
  text-align: left;
  color: #666;
  margin-top: 16px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

const imageWrapperDesktop = css`
  width: auto;
  height: 100%;
  position: absolute;
  right: 24px;
  top: 0;
  overflow: hidden;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
`;

const SearchResultPage = () => {
  const matchesMob = useMediaQuery(MOBLIE_VIEW_WIDTH);
  const navigate = useNavigate();

  const { state } = useLocation();
  const [searchedTerm, setSearchedTerm] = useState(state?.searchedItem || "");
  const [collectionHits, setCollectionHits] = useState();
  const [sliceRange, setSliceRange] = useState(7);

  const routeFinder = (id, slug, title) => {
    const splicedArray = id.split("-");
    const term = splicedArray[0];
    // const Id = splicedArray[2];
    switch (term) {
      case "dealer":
        navigate("/purchase-support/dealer-search");
        break;
      case "news":
        if (splicedArray[1] === "listing") navigate("/news/news-update");
        else navigate(`/news/news-update/news-detail/${slug}`);
        break;
      case "contactus":
        navigate("/contact-us");
        break;
      case "aboutus":
        navigate("/about-us");
        break;
      case "service":
        navigate(`/service-contract-detail/${slug}`);
        break;
      case "car":
        if (splicedArray.length > 3) {
          navigate(`/truck-model-details/${slug}`);
        } else {
          navigate(`/truck-model/${slug}`);
        }
        break;
      case "live":
        if (splicedArray.length > 3) navigate(`/news/live-stream/${slug}`);
        else navigate("/news/live-stream");
        break;
      case "home":
        navigate("/");
        break;
      case "general":
        navigate(`/general-detail-pages/${slug}`);
        break;
      case "events":
        navigate(`/news/events-and-campaigns`);
        break;
      case "campaign":
        navigate(`/news/events-and-campaigns/${slug}`);
        break;
      case "customer":
        navigate("/customer-service", { state: { customerId: title } });
        break;
      case "training":
        if (splicedArray[1] === "listing") navigate("/training-video");
        else navigate(`/training-video/training-detail/${slug}`);
        break;
      case "industry":
        if (splicedArray[1] === "detail")
          navigate(`/industry-detail-pages/${slug}`);
        else navigate(`/industry/${slug}`);
        break;
      case "environmental":
        navigate("/environmentQuery");
        break;
      case "accessories":
        navigate(`/accessories-detail-pages/${slug}`);
        break;
      case "acessories":
        navigate(`/accessories-collec-pages/${slug}`);
        break;
      case "finance":
        if (splicedArray[3] === "detail") {
          navigate(`/finance-leasing-detail/${slug}`);
        } else navigate(`/finance-and-leasing`);
        break;
      case "purchased":
        if (splicedArray[1] === "detail")
          navigate(`/purchased-truck-detail/${slug}`);
        else navigate(`/purchased-truck/${slug}`);
        break;
      case "connected":
        if (splicedArray[1] === "detail") {
          navigate(`/connected-detail/${slug}`);
        } else navigate(`/connected-truck/${slug}`);
    }
  };

  const fetchMeiliSearchData = async (keyword) => {
    const client = new MeiliSearch({
      host: process.env.REACT_APP_MEILISEARCH,
      apiKey: process.env.REACT_APP_MEILISEARCH_KEY,
    });
    const index = await client.getIndex("dtindex");
    const movies = await index.search(keyword);
    setCollectionHits(movies.hits);
  };
  useEffect(() => {
    fetchMeiliSearchData(state?.searchedItem);
    setSearchedTerm(state?.searchedItem);
  }, [state?.searchedItem]);

  const loadMoreClick = () => {
    setSliceRange(sliceRange + 8);
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "61vh",
          backgroundColor: "white",
          display: { xs: "none", md: "flex" },
          padding: "66px 100px 10px",
        }}
      >
        <Box sx={{ width: "33%" }}>
          <Typography
            p={2}
            variant="h1"
            color="black"
            css={(theme) => SearchText(theme)}
            className="title"
          >
            <Typography variant="span">搜索结果</Typography>
          </Typography>
        </Box>
        <Box
          sx={{
            width: "calc(730/1080 * 100%)",
            paddingLeft: "3%",
            paddingTop: "2%",
          }}
        >
          <Box sx={{ display: "flex" }}>
            <TextField
              sx={{
                width: "45%",
                input: {
                  paddingRight: "4%",
                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                },
              }}
              id="standard-basic"
              // placeholder="EQS"
              variant="standard"
              fullWidth
              value={searchedTerm}
              onKeyDown={({ key }) =>
                key === "Enter" && fetchMeiliSearchData(searchedTerm)
              }
              onChange={({ target }) => {
                setSearchedTerm(target.value);
              }}
            />
            <div
              style={{ marginLeft: "-1%", cursor: "pointer" }}
              onClick={() => setSearchedTerm("")}
            >
              <CloseIcon />
            </div>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "black",
                marginLeft: "3%",
                padding: "6px 3%",
                marginTop: "-1%",
                height: "min-content",
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "black",
                },
              }}
              onClick={() => fetchMeiliSearchData(searchedTerm)}
            >
              搜索
            </Button>
          </Box>
          <Box variant="section" sx={{ display: "block" }}>
            <Box css={boxSectionCSS}>
              {collectionHits && collectionHits.length} 个搜索结果
            </Box>

            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              {collectionHits &&
                collectionHits.slice(0, sliceRange).map((d) => {
                  return (
                    <ListItem
                      alignItems="flex-start"
                      key={v4()}
                      css={searchLi}
                      onClick={() => routeFinder(d.id, d.slug, d.title)}
                    >
                      <ListItemText
                        sx={{ maxWidth: "78%" }}
                        primary={
                          <Typography
                            css={primaryTextDesktop}
                            component="span"
                            variant="h5"
                            color="text.primary"
                          >
                            {d.title}
                          </Typography>
                        }
                        secondary={
                          <React.Fragment>
                            <Typography
                              css={secondaryTextDeskTop}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              {d.description || d.title}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                      {(d?.thumbnailImage?.formats ||
                        d?.media?.formats ||
                        d?.serviceTile ||
                        d?.bannerImage ||
                        (d?.body &&
                          (d?.body[0]?.bannerImage?.formats ||
                            d?.body[1]?.bannerImage?.formats ||
                            d?.body[0]?.media?.formats))) && (
                        <Box css={imageWrapperDesktop}>
                          <Box
                            component="img"
                            minHeight="60px"
                            width="108px"
                            sx={{ objectFit: "cover" }}
                            alt={d.title}
                            src={`${process.env.REACT_APP_BASEURL}${
                              d?.thumbnailImage?.formats.thumbnail.url ||
                              d?.media?.formats.thumbnail.url ||
                              (d?.body &&
                                (d?.body[0]?.bannerImage?.formats.thumbnail
                                  .url ||
                                  d?.body[1]?.bannerImage?.formats.thumbnail
                                    .url ||
                                  d?.body[0]?.media?.formats.thumbnail.url)) ||
                              (d.serviceTile &&
                                d?.serviceTile[0]?.media?.formats?.thumbnail
                                  .url)
                            }`}
                          />
                        </Box>
                      )}
                    </ListItem>
                  );
                })}
            </List>
            {collectionHits && collectionHits.length > sliceRange && (
              <Box
                component="span"
                sx={{
                  p: 2,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {
                  <Button
                    sx={{ textDecoration: "underline", color: "black" }}
                    onClick={loadMoreClick}
                  >
                    了解更多
                    <KeyboardArrowDownIcon sx={{ color: "black", p: 1 }} />
                  </Button>
                }
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          minHeight: "61vh",
          backgroundColor: "white",
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          padding: "30px 24px",
        }}
      >
        <Box sx={{ width: "100%", display: "flex", marginBottom: "11%" }}>
          <Typography
            paddingBottom={2}
            variant="h5"
            color="black"
            css={(theme) => SearchText(theme, matchesMob)}
          >
            搜索结果
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            paddingLeft: "3%",
            paddingTop: "2%",
            display: "flex",
          }}
        >
          <TextField
            sx={{ width: "62%", input: { paddingRight: "3%" } }}
            id="standard-basic"
            //  placeholder="EQS"
            variant="standard"
            fullWidth
            value={searchedTerm}
            onKeyDown={({ key }) =>
              key === "Enter" && fetchMeiliSearchData(searchedTerm)
            }
            onChange={({ target }) => {
              setSearchedTerm(target.value);
            }}
          />
          <div
            style={{ marginLeft: "-2%" }}
            onClick={() => setSearchedTerm("")}
          >
            <CloseIcon />
          </div>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "black",
              marginLeft: "3%",
              padding: "6px 3%",
              marginTop: "-2%",
              "&.MuiButtonBase-root:hover": {
                bgcolor: "black",
              },
            }}
            onClick={() => fetchMeiliSearchData(searchedTerm)}
          >
            搜索
          </Button>
        </Box>

        <Box variant="section" sx={{ display: "block" }}>
          <Box css={boxSectionCSS}>
            {collectionHits && collectionHits.length} 个搜索结果
          </Box>

          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            {collectionHits &&
              collectionHits.slice(0, sliceRange).map((d) => {
                return (
                  <ListItem
                    alignItems="flex-start"
                    key={v4()}
                    css={searchLi}
                    onClick={() => routeFinder(d.id)}
                  >
                    <ListItemText
                      primary={
                        <Typography
                          css={primaryTextDesktop}
                          component="span"
                          variant="h5"
                          color="text.primary"
                        >
                          {d.title}
                        </Typography>
                      }
                      secondary={
                        <React.Fragment>
                          <Typography
                            css={secondaryTextDeskTop}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            {d.description || d.title}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                );
              })}
          </List>
          {collectionHits && collectionHits.length > sliceRange && (
            <Box
              component="span"
              sx={{
                p: 2,
                display: "flex",
                justifyContent: "center",
              }}
            >
              {
                <Button
                  sx={{ textDecoration: "underline", color: "black" }}
                  onClick={loadMoreClick}
                >
                  了解更多
                  <KeyboardArrowDownIcon sx={{ color: "black", p: 1 }} />
                </Button>
              }
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default SearchResultPage;
